export var MOBILE_BANNER_COOKIE_NAME = 'mobileBanner';